export const field001Asset = (filename: string, oss: string): string => {
  const prefix =
    process.env.NODE_ENV === "production"
      ? `${oss}field_001/`
      : `${process.env.BASE_URL}detail/field-001/`;

  return `${prefix}${filename}`;
};
